import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "#FECF33";

function IconStatusTag({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12z"/>
        </svg>
    );
}

export default IconStatusTag;
